<div class="view">
  <div class="head">
    <app-breadcrumb [constructor_name]="constructor.name"></app-breadcrumb>
  </div>
  <div class="body">
    <div style="width: 100%; display: flex">
      <div style="width: 50%; display: flex; align-items: center">
        <div>
          <span
            style="
              font-size: 60px;
              font-weight: 700;
              font-family: 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande',
                'Lucida Sans Unicode', Geneva, Verdana, sans-serif;
            "
            >En construcción</span
          >
          <p>
            <span
              style="
                font-size: 40px;
                font-weight: 300;
                font-family: 'Lucida Sans', 'Lucida Sans Regular',
                  'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana,
                  sans-serif;
              "
              >Esta vista aun esta en construcción</span
            >
          </p>
          <br />
          <br />
          <button mat-raised-button color="warn" routerLink="/inicio">
            Volver
          </button>
        </div>
      </div>
      <div style="width: 50%; float: right">
        <img width="100%" src="https://wikipapa.org/images/pngwing.com.png" />
      </div>
    </div>
  </div>
</div>
